export default __webpack_public_path__ + "static/media/Thug's Boots of the Hidden Tomb.e2c40041.jpg";